<template>
  <el-container  style="display: block;">



		<el-row style="width: 100%;margin-top: 50px;margin-left: 10%;" v-for="(item,index) in datalist">
        <div class="t1" @click="erji(item.name)">{{item.name}}</div>
        <div class="t2" v-for="(items,indexs) in item.datas">{{items.name}}</div>

        <div class="t2" @click="adds(item.id)">添加</div>


		</el-row>
    <el-row style="width: 100%;margin-top: 20px;margin-left: 10%;">
        <div class="t1" @click="add()">添加</div>


    </el-row>
   <el-dialog
     title="添加目标库"
     :visible.sync="zhxuanze"
     width="30%"
     center>
     <el-select v-model="base"   filterable placeholder="请选择" >
         <el-option
           v-for="item in bases"
           :key="item.id"
           :label="item.name"
           :value="item.id">
         </el-option>
       </el-select>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="zhxuanze = false">取 消</el-button>
   	<el-button type="primary" @click="doAdds()">确 定</el-button>
     </span>
   </el-dialog>
	 <el-dialog
	  title="添加回应库"
	  :visible.sync="centerDialogVisible"
	  width="40%"
	  center>
    <el-input
      type="input"
      :rows="20"

      placeholder="请输入内容"
      v-model="name">
    </el-input>
	  <span slot="footer" class="dialog-footer">
		<el-button @click="centerDialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdd()">确 定</el-button>
	  </span>
	</el-dialog>

  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        datalist:[],
        bases:[],
        zhxuanze:false,
        base:0,
        name:'',
        b_id:0,
        centerDialogVisible:false
      };
    },
	directives: {
      focus: {
        inserted: function(el, { value }) {
          if (value) {
            el.focus();
          }
        }
      }
	  },
    created() {


       this.loadData();


    },

	methods:{
    erji(name){
      if(name == '儿童机器人'){
        this.$router.push({ path: '/Acfuzhi' })
      }
      if(name == '机器体向'){
        this.$router.push({ path: '/Acfuzhib' })
      }
      if(name == '礼貌向'){
        this.$router.push({ path: '/Acfuzhic' })
      }
    },
    adds(id){
      this.b_id = id
      this.zhxuanze = true
    },
    doAdds(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          b_id:this.b_id,
          id:this.base
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/bcbaseadd'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.zhxuanze = false
          this.b_id = 0
          this.msg('添加成功','success');
          this.loadData()
        }else{
          this.msg('添加失败','error');


        }



      })
      .catch(err=>{

      });
    },
    doAdd(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{

          name:this.name
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/bcadd'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.centerDialogVisible = false
          this.msg('添加成功','success');
          this.loadData()
        }else{
          this.msg('添加失败','error');


        }



      })
      .catch(err=>{

      });
    },
    add(){
      this.centerDialogVisible = true
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:''
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/bclist'
			})
			.then(res=>{
				this.datalist = res.data.data;
        this.bases = res.data.bases;
			})
			.catch(err=>{

			});
		},

		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



		}



  }
</script>
<style>
  .t1{
    border: 1px solid #d5c8c8;
    margin-left: 10px;
    float: left;
    width: 150px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #0086B3;
    color: #fff;
  }
  .t2{
    border: 1px solid #d5c8c8;
    margin-left: 10px;
    float: left;
    width: 150px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #42B983;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/acfuzhih.vue